let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lY5k8")).then(() => parcelRequire('1R9Bg'));